export const Breakpoints = {
  sm: 560,
  md: 865,
  lg: 960,
  header: 1250,
  xl: 1440,
  xxl: 1600,
};

const brPx = {};
Object.keys(Breakpoints).map((key) => {
  brPx[key] = `${Breakpoints[key]}px`;
});

export const BreakpointsWithPx = brPx;

